import React, { useState } from "react";
import "./Gallery.css";

// ✅ IMPORT IMAGES PROPERLY
import img1 from "../images/gallery/1.jpeg";
import img2 from "../images/gallery/2.jpeg";
import img3 from "../images/gallery/3.jpeg";
import img4 from "../images/gallery/4.jpeg";
import img5 from "../images/gallery/5.jpeg";
import img6 from "../images/gallery/6.jpeg";
import img7 from "../images/gallery/7.jpeg";
import img8 from "../images/gallery/8.jpeg";
import img9 from "../images/gallery/9.jpeg";
import img10 from "../images/gallery/10.jpeg";
import img11 from "../images/gallery/11.jpeg";
import img12 from "../images/gallery/12.jpeg";
import img13 from "../images/gallery/13.jpeg";
//import img14 from "../images/gallery/14.jpeg";
//import img15 from "../images/gallery/15.jpeg";
import img16 from "../images/gallery/16.jpeg";
import img17 from "../images/gallery/17.jpeg";
import img18 from "../images/gallery/18.jpeg";
import img19 from "../images/gallery/19.jpeg";
//import img20 from "../images/gallery/20.jpeg";
import img21 from "../images/gallery/21.jpeg";
import img22 from "../images/gallery/22.jpeg";
//import img23 from "../images/gallery/23.jpeg";
//import img24 from "../images/gallery/24.jpeg";
import img25 from "../images/gallery/25.jpeg";
//import img26 from "../images/gallery/26.jpeg";
import img27 from "../images/gallery/27.jpeg";
import img28 from "../images/gallery/28.jpeg";
//import img29 from "../images/gallery/29.jpeg";
import img30 from "../images/gallery/30.jpeg";
import img31 from "../images/gallery/31.jpeg";
import img32 from "../images/gallery/32.jpeg";

const images = [
  img1, img2, img3, img4, img5,
  img6, img7, img8, img9, img10,
  img11, img12, img13, img16, img17, 
  img18, img19, img21, img22,  img25,
  img27, img28,  img30, img31, img32
];

const Gallery = () => {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const closeViewer = () => setSelectedIndex(null);
  const prevImage = () =>
    setSelectedIndex((selectedIndex + images.length - 1) % images.length);
  const nextImage = () =>
    setSelectedIndex((selectedIndex + 1) % images.length);

  return (
    <section id="gallery">
      <div className="gallery-container">
        <h2 className="gallery-title">
          <span>Our</span> Gallery
        </h2>

        {/* ✅ GRID */}
        <div className="gallery-grid">
          {images.map((img, index) => (
            <div
              key={index}
              className="gallery-thumb"
              onClick={() => setSelectedIndex(index)}
            >
              <img src={img} alt={`Gallery ${index}`} />
            </div>
          ))}
        </div>
      </div>

      {/* ✅ VIEWER */}
      {selectedIndex !== null && (
        <div className="image-modal" onClick={closeViewer}>
          <button
            className="nav-btn left"
            onClick={(e) => {
              e.stopPropagation();
              prevImage();
            }}
          >
            ❮
          </button>

          <img src={images[selectedIndex]} alt="Preview" />

          <button
            className="nav-btn right"
            onClick={(e) => {
              e.stopPropagation();
              nextImage();
            }}
          >
            ❯
          </button>
        </div>
      )}
    </section>
  );
};

export default Gallery;
